<template>
  <div class="flex-1 mx-auto flex flex-col">
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 space-y-8">
        
        <div class="w-full flex flex-row justify-between items-center">
          <h2 class="flex-none text-xl font-medium text-gray-900">
            Content Requests
          </h2>
          <button class="bg-blue-700 text-white rounded-lg px-3 py-1.5" v-on:click="displayCreateContentModal = !displayCreateContentModal">Create Request</button>
        </div>

        <!-- Activity list (smallest breakopoint only) -->
        <div class="shadow sm:hidden">
          <ul
            class="mt-2 divide-y divide-gray-200 overflow-hidden shadow sm:hidden"
          >
            <li v-for="request in requests" v-bind:key="'mobile-' + request.id">
              <div class="block px-2 py-2 bg-white hover:bg-gray-50">
                <span class="flex items-center space-x-4">
                  <span class="flex-1 flex space-x-2 truncate">
                    <div class="flex-1 px-3 py-1 whitespace-nowrap">
                      <div class="flex items-center">
                        <div class="ml-4">
                          <div  class="text-sm font-medium text-gray-900">
                            {{ request.title }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="px-3 py-1 whitespace-nowrap flex items-center">
                      <div class="text-sm text-gray-900">
                        {{
                          request.created_at | displayLocalDateTime("MM/DD/YY")
                        }}
                      </div>
                    </div>
                    <div class="px-3 py-1 whitespace-nowrap flex items-center">
                      <span
                        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                      >
                        Active
                      </span>
                    </div>
                  </span>
                </span>
              </div>
            </li>
          </ul>
        </div>

        <!-- Activity table (small breakopoint and up) -->
        <div class="hidden sm:block">
            <div class="flex flex-col mt-2">
              <div
                class="shadow overflow-auto border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Request Title
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Deadline
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Requesting User
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr
                      v-for="request in requests"
                      v-bind:key="'dtop-' + request.id"
                      class="hover:bg-gray-100 cursor-pointer"
                      v-on:click="$router.push({'name': 'MediaContentRequest', params: {id: request.id}})"
                    >
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="flex items-center">
                          <div class="text-sm font-medium text-gray-900">
                            {{ request.title }}
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          {{
                            request.created_at | displayLocalDateTime("MM/DD/YY")
                          }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span
                          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                        >
                          Active
                        </span>
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ request.requesting_network !== null ? request.requesting_user.name : "Live Storms Media" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
      </div>
    </main>
    <Modal
      :open="displayCreateContentModal"
      title="Create Content Request"
      size="large"
      modalIcon="fad fa-lightbulb-exclamation-on"
      modalIconColor="bg-blue-100 text-blue-700"
      :showEscapeButton="true"
      :showAcceptButton="true"
      acceptButtonText="Create Request"
      @close="displayCreateContentModal = false"
      @onSuccess="createRequest"
      ref="modal"
    >
      <div class="space-y-4">
        <div>
          <label
            for="title"
            class="block text-sm font-medium text-gray-700"
            >Title</label
          >
          <input
            type="text"
            name="title"
            id="title"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="modalData.title"
          />
        </div>

        <div>
          <label
            for="description"
            class="block text-sm font-medium text-gray-700"
            >Description</label
          >
          <textarea
            id="description"
            name="description"
            rows="4"
            class="shadow-sm focus:ring-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
            v-model="modalData.description"
          ></textarea>
        </div>

        <div class="grid grid-cols-2 space-x-4">
          <div class="">
            <label
              for="type"
              class="block text-sm font-medium text-gray-700"
              >Request Type</label
            >
            <select
              class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              v-model="modalData.type"
              name="type"
              id="type"
            >
              <option v-for="type in videoTypes" :value="type.id" v-bind:key="type.id">{{ type.display }}</option>
            </select>
          </div>
          <div class="">
            <label
              for="deadline"
              class="block text-sm font-medium text-gray-700"
              >Deadline <span class="text-xs font-normal">(YYYY-MM-DD hh:mm) 24-hour format</span></label
            >
            <input
              type="text"
              name="deadline"
              id="deadline"
              class="mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
              :class="{
                'border-gray-300 focus:ring-blue-500 focus:border-blue-500 sm:text-sm': !formatIssues,
                'border-red-300 focus:ring-red-500 focus:border-red-500': formatIssues}"
              v-model="deadline"
            />
            <span class="text-sm" :class="{'text-red-600': formatIssues}">{{ !formatIssues ? datetimeDisplay : 'Format not valid'}}</span>
          </div>
        </div>
      </div>

    </Modal>
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapGetters } from "vuex";
import CustomTable from "@/components/general/CustomTable";
import AccountIcon from "@/components/AccountIcon";

import moment from "moment";
import Modal from "@/components/Modal";

export default {
  name: "MediaNetworkMembers",
  data() {
    return {
      requests: [],
      polling: true,
      displayCreateContentModal: false,
      formatIssues: false,
      datetimeDisplay: null,
      deadline: null,
      modalData: {
        title: null,
        description: null,
        deadline: null,
        type: 'eng',
      },
      videoTypes: [
        {
          id: 'eng',
          display: "B-Roll/ENG",
        },
        {
          id: 'stock',
          display: "Stock"
        }
      ]
    };
  },
  mounted() {
    this.getRequests();
  },
  components: { CustomTable, AccountIcon, Modal },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    async getRequests() {
      try {
        let res = await this.$http.get(
          Config.apiPath +
            "/api/v2/media/requests",
          this.getAuthorizationHeader()
        );
        this.requests = res.data
      } catch (e) {
        console.log(e)
      }
    },
    async createRequest() {
      try {
        let res = await this.$http.post(
          Config.apiPath +
            "/api/v2/media/requests",
          this.modalData,
          this.getAuthorizationHeader()
        );
        this.displayCreateContentModal = false
        this.$swal(
          'Request Submitted!',
          'The request has been created. Check back for updates as content is added.',
          'success'
        )
      } catch (e) {
        console.log(e)
      }
    }
  },
  watch: {
    'deadline': function(value) {
      var parsedDate = moment(value, "YYYY-MM-DD hh:mm:ss")
      if(parsedDate.isValid()) {
        this.formatIssues = false
        this.datetimeDisplay = parsedDate.toString()
        this.modalData.deadline = parsedDate.utc().format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.formatIssues = true
      }
    }
  },
};
</script>
